/* AVELY GLOW - bundle builder
   Ajoute N variantes reelles au panier via /cart/add.js, puis applique
   le code de reduction associe a l'offre via /discount/<code>?redirect=/cart.
   Le panier est vide avant l'ajout pour que le prix annonce corresponde
   exactement au prix paye : les codes sont des remises a montant fixe,
   appliquees une seule fois et non cumulables entre elles.
   Aucune variante fictive, aucun prix code en dur cote panier. */
(function () {
  'use strict';

  if (window.__avelyOffersInit) return;
  window.__avelyOffersInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initOffer(form) {
    var root = form.closest('[data-avely-offers]');
    if (!root) return;

    var dataEl = root.querySelector('[data-avely-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var lookup = {};
    variants.forEach(function (v) {
      lookup[v.o1 + ' :: ' + v.o2] = v;
    });

    var errorEl = form.querySelector('[data-avely-error]');
    var button = form.querySelector('[data-avely-submit]');

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.setAttribute('data-visible', 'true');
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.removeAttribute('data-visible');
      errorEl.textContent = '';
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearError();

      var slots = form.querySelectorAll('[data-avely-slot]');
      var items = [];
      var missing = false;
      var unavailable = false;

      Array.prototype.forEach.call(slots, function (slot) {
        var c = slot.querySelector('[data-avely-color]');
        var s = slot.querySelector('[data-avely-size]');
        if (!c || !s || !c.value || !s.value) {
          missing = true;
          return;
        }
        var found = lookup[c.value + ' :: ' + s.value];
        if (!found || found.available === false) {
          unavailable = true;
          return;
        }
        items.push({ id: found.id, quantity: 1 });
      });

      if (missing) {
        showError('Choisissez un coloris et une taille pour chaque ensemble.');
        return;
      }
      if (unavailable || items.length === 0) {
        showError("Une des combinaisons choisies n'est pas disponible.");
        return;
      }

      var code = form.getAttribute('data-discount-code') || '';
      var originalLabel = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Ajout en cours...';
      }

      var shopRoot =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

      fetch(shopRoot + 'cart/clear.js', {
        method: 'POST',
        headers: headers
      })
        .then(function (res) {
          if (!res.ok) throw new Error('clear');
          return fetch(shopRoot + 'cart/add.js', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(function () {
          if (code) {
            window.location.href =
              shopRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + shopRoot + 'cart';
          } else {
            window.location.href = shopRoot + 'cart';
          }
        })
        .catch(function () {
          if (button) {
            button.disabled = false;
            button.textContent = originalLabel;
          }
          showError("L'ajout au panier a échoué. Merci de réessayer.");
        });
    });
  }

  ready(function () {
    var forms = document.querySelectorAll('[data-avely-offer-form]');
    Array.prototype.forEach.call(forms, initOffer);
  });
})();
